const protocol = require('@/api/protocol.js')

/**
 * translate
 *
 */
const sitemap = {}

sitemap.getAll = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/sitemap'
    const method = 'get'
    const params = { lng: e.lng }
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

function getDataObject (e, params) {
  const data = {}
  if (typeof e === 'object') {
    for (const [key, value] of Object.entries(e)) {
      data[key] = value
    }
    return data
  } else return {}
}
module.exports = sitemap
